import { useSyncExternalStore } from "react";
import { api } from "@/lib/api";

let keys = new Set();
let loaded = false;
const subs = new Set();
const emit = () => subs.forEach((f) => f());

function subscribe(f) {
  subs.add(f);
  if (!loaded) {
    loaded = true;
    api.get("/reminders/shows").then((r) => { keys = new Set(r.data); emit(); }).catch(() => { loaded = false; });
  }
  return () => subs.delete(f);
}

export const reminderKey = (item, s) => `${item.id}|${s.date}|${s.time || ""}`;

export function useShowReminders() {
  const snap = useSyncExternalStore(subscribe, () => keys);
  const toggle = async (item, s, city) => {
    const { data } = await api.post("/reminders/shows", { listing: item, date: s.date, time: s.time || "", title: s.title || item.name, city: city || "" });
    keys = new Set(keys);
    if (data.on) keys.add(data.key); else keys.delete(data.key);
    emit();
    return data.on;
  };
  return { keys: snap, toggle };
}
